// Runs a proposal-extraction job on the backend WITHOUT hitting Cloudflare's
// ~100s edge timeout. Posts to a `/start` endpoint that returns a job_id, then
// polls GET /dno/proposal-job/{job_id} until the AI finishes. Returns the same
// result shape the old synchronous endpoints returned (e.g. {extracted, ...}).
//
// `formData` may be null for endpoints that take no body (e.g. re-extract).
export async function runProposalJob(api, startUrl, formData = null, { onProgress, timeoutMs = 300000 } = {}) {
  const config = formData
    ? { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }
    : { timeout: 120000 };
  const { data } = await api.post(startUrl, formData, config);

  // Backward-compat: if a server returned the full result directly, use it.
  if (!data?.job_id) return data;

  const jobId = data.job_id;
  const deadline = Date.now() + timeoutMs;
  // small initial delay before first poll so quick jobs still feel snappy
  while (Date.now() < deadline) {
    await new Promise((r) => setTimeout(r, 2500));
    let st;
    try {
      const res = await api.get(`/dno/proposal-job/${jobId}`);
      st = res.data;
    } catch {
      continue; // transient — keep polling
    }
    if (onProgress) onProgress(st);
    if (st.status === 'done') return st.result;
    if (st.status === 'error') {
      const e = new Error(st.error || 'Proposal extraction failed');
      e.isExtractionError = true;
      throw e;
    }
  }
  const e = new Error('Extraction is taking longer than expected. Please try again.');
  e.isTimeout = true;
  throw e;
}

export default runProposalJob;
